import { postApi } from "./api_instance";

export const transactionReply = async (info, dispatch) => {
  try {
    const { data } = await postApi({
      apiUrl: "/payments/api/transactions/communication/reply",
      sendToken: true,
      data: info,
      dispatch,
    });
    return data;
  } catch (error) {
    throw error;
  }
};
